import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {filterDate_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDate_template";
import {resultsInfo_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";
import {filterArticle_template} from "./filterArticle_template";
import {
    multipleSelector_template
} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import {infoButton_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/infoButton_template";

declare var ko: any;

export class pollsList_template extends vnTemplate {

    protected filter: filterSimple_template;
    protected dateFilter: filterDate_template;
    protected commercialExportDateFilter!: filterDate_template;
    protected commercialExportBrandFilter!: multipleSelector_template;
    protected commercialExportSignalFilter!: multipleSelector_template;
    protected pollImportTooltip!: infoButton_template;
    protected pagination: pagination_template;
    protected resultInfos: resultsInfo_template;

    protected getTemplateHtml(): string {

        return `
                <div class="sub-header w-justify">
                    <div class="w-left">
                        ${ this.dateFilter.getHtmlBuild() }
                    </div>
                </div>
                <div class="w-filters-selected">
                    <div id="filters-selected" class="filters-selected">
                        <div id="selected-brands"></div>
                    </div>
                </div>

                <div class="list-header w-justify" >

                    <div class="w-left" data-bind="if: isAddButtonShown">
                        <button data-bind="click: onClickAddPoll" class="btn secondary icon i-add" type="button">Create Poll</button>
                        <button data-bind="click: onClickShowPollImport" class="btn secondary icon i-upload" style="margin-left: 10px;" type="button">Import Polls</button>
                    </div>

                    <div class="w-center">
                         ${this.filter.getHtmlBuild()}
                    </div>

                    <div class="w-right">
                        <button style="margin: 10px" data-bind="click : onClickExportToCSV, css: { 'is-disable': exportInProgress, 'is-hidden': listIsEmpty }, text : exportTextBox" class="btn secondary icon i-export" type="button">Export to CSV</button>
                        <!-- ko if: permissions()['website_user_export'] && permissions()['website_user_export'].read -->
                        <button style="margin: 10px" data-bind="click: onClickShowCommercialExport, disable: commercialExportInProgress" class="btn secondary icon i-export" type="button">Export Commercial Data</button>
                        <!-- /ko -->
                        ${this.pagination.getHtmlBuild()}
                    </div>
                </div>

            <div class="w-list-results" id="list-results">
                <table class="list-results">
                    ${ this.resultInfos.getHtmlBuild() }
                    <thead>
                        <tr>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'id') }, css: { 'list-sort-desc': orderByAndDirection()=='id_DESC', 'list-sort-asc': orderByAndDirection()=='id_ASC' }">ID</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'name') }, css: { 'list-sort-desc': orderByAndDirection()=='name_DESC', 'list-sort-asc': orderByAndDirection()=='name_ASC' }">Name</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateCreated') }, css: { 'list-sort-desc': orderByAndDirection()=='dateCreated_DESC', 'list-sort-asc': orderByAndDirection()=='dateCreated_ASC' }">Date Created</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateClosed') }, css: { 'list-sort-desc': orderByAndDirection()=='dateCreated_DESC', 'list-sort-asc': orderByAndDirection()=='dateCreated_ASC' }">Close Date</span></th>
                        </tr>
                    </thead>
                    <tbody data-bind="foreach: polls">
                        <tr class="cursor">
                            <td data-bind="event: { click: $parent.onClickEdit }"><a class="right-click" data-bind="attr: {href: emakiView}"><span data-bind="text: id"></span></a></td>
                            <td data-bind="event: { click: $parent.onClickEdit }"><a class="right-click" data-bind="attr: {href: emakiView}"><span data-bind="text: name"></span></a></td>
                            <td data-bind="event: { click: $parent.onClickEdit }"><a class="right-click" data-bind="attr: {href: emakiView}"><span data-bind="text: dateCreated"></span></a></td>
                            <td data-bind="event: { click: $parent.onClickEdit }"><a class="right-click" data-bind="attr: {href: emakiView}"><span data-bind="text: dateClosed"></span></a></td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div id="poll-import-dialog" class="w-lightbox light-theme poll-import-lightbox" data-bind="css: { 'is-visible': isPollImportModalVisible }">
                <div id="poll-import-dialog-content" class="lightbox-content website-user-delete">
                    <div class="w-form lightbox-form">
                        <div class="form-header">
                            <h3 class="form-title">Import Polls</h3>
                            <button type="button" data-bind="event: { click: onClickCancelPollImport }" class="close-button icon i-close-2"></button>
                        </div>
                        <div class="form-body scroll">
                            <div class="form-group">
                                <div style="display: flex; align-items: center; gap: 8px;">
                                    <label class="form-label">CSV Import Guidance</label>
                                    <div class="w-tooltips-adv pos-bottom short import-guidance-tooltip">
                                        ${this.pollImportTooltip.getHtmlBuild()}
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="form-label">CSV File</label>
                                <div class="import-file-actions">
                                    <div class="dropzone needsclick dz-clickable"
                                         data-bind="css: { 'is-drag-over': isPollImportDragOver, 'has-file': pollImportFileName },
                                                    event: { dragover: onPollImportDragOver, dragleave: onPollImportDragLeave, drop: onPollImportDrop }">
                                        <input id="poll-import-csv-file" class="input-file-btn icon" name="csvFile" type="file" accept=".csv,text/csv" data-bind="css: { 'i-upload': !pollImportFileName(), 'i-file': !!pollImportFileName() }, event: { change: onPollImportFileSelected }">
                                        <p class="form-text" data-bind="text: pollImportFileName() ? pollImportFileName() : 'Drag and drop a CSV file here, or click to choose one.'"></p>
                                    </div>
                                    <button type="button" data-bind="visible: pollImportFileName, event: { click: onClickRemovePollImportFile }" class="btn border icon i-delete import-file-remove">Remove file</button>
                                </div>
                                <p class="form-text" data-bind="visible: pollImportValidating">Validating CSV file...</p>
                                <p class="form-text alert-success import-validation-success" data-bind="visible: pollImportIsValid">CSV file is valid.</p>
                                <div class="import-validation-errors" data-bind="visible: pollImportValidationErrors().length > 0">
                                    <ul data-bind="foreach: pollImportValidationErrors">
                                        <li class="form-text alert-error" data-bind="text: $data"></li>
                                    </ul>
                                </div>
                            </div>
                            <div class="form-group import-commercial-signals">
                                <input id="poll-import-generate-commercial-signals" type="checkbox" data-bind="checked: pollImportGenerateCommercialSignals">
                                <label class="icon i-check" for="poll-import-generate-commercial-signals">Generate Commerical Signals, Entities, & Values</label>
                            </div>
                            <div class="form-group" data-bind="visible: pollImportInProgress">
                                <img src="/assets/images/loading-2.svg" alt="" class="export-loading-spinner" data-bind="visible: pollImportInProgress">
                                <p class="form-text">Importing polls...</p>
                            </div>
                            <div class="form-group">
                                <p class="form-text" style="font-weight: 600;">There is a delay for the polls creation after the polls import is completed.</p>
                            </div>
                        </div>
                        <div class="form-footer">
                            <button type="button" data-bind="event: { click: onClickCancelPollImport }" class="btn">Cancel</button>
                            <button type="button" data-bind="event: { click: onClickConfirmPollImport }, disable: !pollImportFileName() || pollImportValidating() || !pollImportIsValid() || pollImportInProgress()" class="btn highlight">Import Polls</button>
                        </div>
                    </div>
                </div>
            </div>

            <div id="poll-commercial-export-dialog" class="w-lightbox light-theme poll-commercial-export-lightbox" data-bind="css: { 'is-visible': isCommercialExportModalVisible }">
                <div id="poll-commercial-export-dialog-content" class="lightbox-content website-user-delete">
                    <div class="w-form lightbox-form">
                        <div class="form-header">
                            <h3 class="form-title">Export Commercial Data</h3>
                            <button type="button" data-bind="event: { click: onClickCancelCommercialExport }" class="close-button icon i-close-2"></button>
                        </div>
                        <div class="form-body scroll">
                            <p class="form-text" style="text-align: center;">Select a time range, brands, and commercial signals to export.</p>
                            <div class="poll-commercial-export-filter-row">
                                <div>
                                    ${ this.commercialExportDateFilter.getHtmlBuild() }
                                </div>
                                <div>
                                    ${ this.commercialExportBrandFilter.getHtmlBuild() }
                                </div>
                                <div>
                                    ${ this.commercialExportSignalFilter.getHtmlBuild() }
                                </div>
                            </div>
                            <div class="w-filters-selected">
                                <div id="poll-commercial-export-filters-selected" class="filters-selected">
                                    <div id="poll-commercial-export-selected-brands"></div>
                                    <div id="poll-commercial-export-selected-signals"></div>
                                </div>
                            </div>
                            <div class="form-group" data-bind="visible: commercialExportInProgress">
                                <img src="/assets/images/loading-2.svg" alt="" class="export-loading-spinner" data-bind="visible: commercialExportInProgress">
                                <p class="form-text" data-bind="text: commercialExportProgressText"></p>
                            </div>
                        </div>
                        <div class="form-footer">
                            <button type="button" data-bind="event: { click: onClickCancelCommercialExport }, disable: commercialExportCancelling" class="btn">Cancel</button>
                            <button type="button" data-bind="event: { click: onClickConfirmCommercialExport }, disable: commercialExportInProgress" class="btn highlight">Confirm</button>
                        </div>
                    </div>
                </div>
            </div>

            `;
    }

    protected initPartial(): void {

        this.filter = new filterSimple_template("filter", this.getTemplateViewModel(), this.caller);
        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 25;
        this.resultInfos = new resultsInfo_template("resultInfo", this.getTemplateViewModel(), this.caller)

        this.dateFilter = new filterDate_template("dateFilter", this.getTemplateViewModel(), this.caller);
        this.dateFilter.getTemplateViewModel().startDate(null);
        this.dateFilter.getTemplateViewModel().endDate(null);
        this.dateFilter.toggleClearButton(true);
        this.dateFilter.setLabel('Date Created');

        this.commercialExportDateFilter = new filterDate_template("commercialExportDateFilter", this.getTemplateViewModel(), this.caller);
        this.commercialExportDateFilter.setStartPickerId("commercialExportStartDatePicker");
        this.commercialExportDateFilter.setEndPickerId("commercialExportEndDatePicker");
        this.commercialExportDateFilter.toggleClearButton(true);
        this.commercialExportDateFilter.setLabel('Response Date');

        this.commercialExportBrandFilter = new multipleSelector_template("commercialExportBrandFilter", this.getTemplateViewModel(), this.caller);
        this.commercialExportBrandFilter.setLabel("Brands");
        this.commercialExportBrandFilter.setFilterContainerClass('margin-neg');
        this.commercialExportBrandFilter.setTagContainerId('poll-commercial-export-selected-brands');
        this.commercialExportBrandFilter.setTagContainerCaption('Selected brands:');

        this.commercialExportSignalFilter = new multipleSelector_template("commercialExportSignalFilter", this.getTemplateViewModel(), this.caller);
        this.commercialExportSignalFilter.setLabel("Commercial Signals");
        this.commercialExportSignalFilter.setFilterContainerClass('margin-neg');
        this.commercialExportSignalFilter.setTagContainerId('poll-commercial-export-selected-signals');
        this.commercialExportSignalFilter.setTagContainerCaption('Selected commercial signals:');

        this.pollImportTooltip = new infoButton_template("pollImportTooltip", this.getTemplateViewModel(), this.caller);
        this.pollImportTooltip.setTitle("Import Polls Help");
        this.pollImportTooltip.setContent(`
            <div>
                <p>Create a CSV file with this exact header row:</p>
                <p><b>poll, brands, question, questionType, questionSection, choices</b></p>
                <ul class="import-guidance-tooltip-list">
                    <li><b>poll</b>: required poll name. Rows with the same poll name are grouped into one poll.</li>
                    <li><b>brands</b>: optional pipe-separated brand short names, for example <b>brand-a|brand-b</b>. Empty uses the current brand.</li>
                    <li><b>question</b>: required question text.</li>
                    <li><b>questionType</b>: required. Use <b>single</b> or <b>multi</b>.</li>
                    <li><b>questionSection</b>: optional. Empty becomes <b>Unassigned</b>. A poll cannot mix Unassigned rows with named sections.</li>
                    <li><b>choices</b>: required pipe-separated choice text, for example <b>Yes|No|Maybe</b>.</li>
                </ul>
                <p>Save the file as CSV before uploading.</p>
            </div>
        `);

    }

    protected getTemplateName(): string {
        return "pollsList-template";
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): Array<string> {
        return ["w-content"];
    }

    protected buildViewModel(): any {

        // define the viewmodel data/ functions
        let self = this;
        return {
            brandId: ko.observable(null),
            orderBy: ko.observable("dateCreated"),
            orderByDirection: ko.observable("DESC"),
            polls: ko.observableArray([]),
            orderByAndDirection: ko.observable("dateCreated_DESC"),
            isAddButtonShown: ko.observable(true),
            name : ko.observable(''),
            exportInProgress: ko.observable(false),
            listIsEmpty: ko.observable(false),
            exportTextBox: ko.observable("Export to CSV"),
            permissions: ko.observable({website_user_export: {read: false}}),
            isCommercialExportModalVisible: ko.observable(false),
            commercialExportInProgress: ko.observable(false),
            commercialExportProgressText: ko.observable(''),
            commercialExportCancelling: ko.observable(false),
            isPollImportModalVisible: ko.observable(false),
            isPollImportDragOver: ko.observable(false),
            pollImportFileName: ko.observable(''),
            pollImportInProgress: ko.observable(false),
            pollImportValidating: ko.observable(false),
            pollImportIsValid: ko.observable(true),
            pollImportValidationErrors: ko.observableArray([]),
            pollImportGenerateCommercialSignals: ko.observable(false),
            onClickReorder: (value, data, event) =>{
                self.onClickReorder(value, data, event);
            },
            onClickAddPoll: () => {
                self.onClickAddPoll();
            },
            onClickEdit: (data) => {
                self.onClickEdit(data);
            },
            onClickExportToCSV: (data) => {
                self.onClickExportToCSV(data)
            },
            onClickShowCommercialExport: () => {
                self.onClickShowCommercialExport();
            },
            onClickConfirmCommercialExport: () => {
                self.onClickConfirmCommercialExport();
            },
            onClickCancelCommercialExport: () => {
                self.onClickCancelCommercialExport();
            },
            onClickShowPollImport: () => {
                self.onClickShowPollImport();
            },
            onPollImportFileSelected: (data, event) => {
                self.onPollImportFileSelected(data, event);
            },
            onPollImportDragOver: (data, event) => {
                self.onPollImportDragOver(data, event);
            },
            onPollImportDragLeave: (data, event) => {
                self.onPollImportDragLeave(data, event);
            },
            onPollImportDrop: (data, event) => {
                self.onPollImportDrop(data, event);
            },
            onClickRemovePollImportFile: () => {
                self.onClickRemovePollImportFile();
            },
            onClickConfirmPollImport: () => {
                self.onClickConfirmPollImport();
            },
            onClickCancelPollImport: () => {
                self.onClickCancelPollImport();
            }
        };
    }

    public buildDatePickerCalendar(){

        this.dateFilter.buildCalendar();
    }

    public buildCommercialExportDatePickerCalendar() {

        this.commercialExportDateFilter.buildCalendarWhenReady();
    }

    // poll save model
    public buildPollViewModel(){

        return {
            name: this.getTemplateViewModel().name
        }
    }

    // implementation of base class [vnTemplate]
    public getViewModelForRequest() {

        return {
            orderBy: this.getTemplateViewModel().orderBy,
            orderByDirection: this.getTemplateViewModel().orderByDirection,
            orderByAndDirection: this.getTemplateViewModel().orderByAndDirection,
            pagination: this.getTemplateViewModel().pagination,
            filters      : {
                keywords : this.getTemplateViewModel().filter.filterKeyword,
                startDate: this.getTemplateViewModel().dateFilter.startDate,
                endDate: this.getTemplateViewModel().dateFilter.endDate
            },
        }
    }


    public onClickReorder(value, data, event) {

        data.orderBy(value);
        //if column has already been sorted, flip the direction
        if (data.orderByAndDirection().includes(value)) {
            if (data.orderByDirection() == "DESC") {
                data.orderByDirection("ASC");
            } else {
                data.orderByDirection("DESC");
            }
        } else {
            //default column sort direction
            data.orderByDirection("DESC");
        }

        data.orderByAndDirection(value + "_" + data.orderByDirection());

        this.caller.pollsListReorder();
    }

    public onClickAddPoll() {

        this.caller.addPoll();
    }

    public setPolls(polls) {

        this.getTemplateViewModel().polls(polls);
    }

    public onClickEdit(data){
        this.caller.viewPoll(data.emakiView);
    }


    // public onClickEdit(data){
    //     this.caller.viewPoll(data.id);
    // }

    public onClickExportToCSV(data) {
        console.log('onClickExportToCSV', data);
        this.asExportInProgress(true);
        this.setExportTextBox("Exporting...");

        this.caller.exportList();
    }

    public onClickShowCommercialExport() {
        this.caller.showCommercialExportModal();
    }

    public onClickConfirmCommercialExport() {
        this.caller.exportCommercialData();
    }

    public onClickCancelCommercialExport() {
        this.caller.cancelCommercialExport();
    }

    public onClickShowPollImport() {
        this.caller.showPollImportModal();
    }

    public onPollImportFileSelected(data, event) {
        this.caller.selectPollImportFile(event.target.files && event.target.files[0] ? event.target.files[0] : null);
    }

    public onPollImportDragOver(data, event) {
        event.preventDefault();
        this.getTemplateViewModel().isPollImportDragOver(true);
    }

    public onPollImportDragLeave(data, event) {
        event.preventDefault();
        this.getTemplateViewModel().isPollImportDragOver(false);
    }

    public onPollImportDrop(data, event) {
        event.preventDefault();
        this.getTemplateViewModel().isPollImportDragOver(false);
        const dropEvent = event.originalEvent || event;
        this.caller.selectPollImportFile(dropEvent.dataTransfer.files && dropEvent.dataTransfer.files[0] ? dropEvent.dataTransfer.files[0] : null);
    }

    public onClickRemovePollImportFile() {
        this.caller.removePollImportFile();
    }

    public onClickConfirmPollImport() {
        this.caller.importPolls();
    }

    public onClickCancelPollImport() {
        this.caller.cancelPollImport();
    }

    public setBrandId(brandId) {
        this.getTemplateViewModel().brandId(brandId);
    }

    public getBrandId() {
        return this.getTemplateViewModel().brandId();
    }

    public setAddButtonShown(isAddButtonShown: boolean) {

        this.getTemplateViewModel().isAddButtonShown(isAddButtonShown);
    }

    public setResultInfo(nbResults, nbPages, execTime ) {

        this.resultInfos.setExecutionTime(execTime);
        this.resultInfos.setNbResults(nbResults);
        this.resultInfos.setNbPages(nbPages);
    }

    public asExportInProgress(exportInProgress) {
        this.getTemplateViewModel().exportInProgress(exportInProgress);
    }

    public isExportInProgress() {
        return this.getTemplateViewModel().exportInProgress();
    }

    public setListIsEmpty(listIsEmpty) {
        this.getTemplateViewModel().listIsEmpty(listIsEmpty);
    }

    public isListIsEmpty() {
        return this.getTemplateViewModel().listIsEmpty();
    }

    public setExportTextBox(exportTextBox) {
        this.getTemplateViewModel().exportTextBox(exportTextBox);
    }

    public getExportTextBox() {
        return this.getTemplateViewModel().exportTextBox();
    }

    public setPermissions(permissions) {
        this.getTemplateViewModel().permissions(permissions || {website_user_export: {read: false}});
    }

    public setCommercialExportBrands(brands: Array<any>) {
        this.commercialExportBrandFilter.setItems(brands || []);
    }

    public setCommercialExportSignals(signalTypes: Array<any>) {
        const items = (signalTypes || []).map((signalType: any) => {
            return {id: signalType.label, name: signalType.label};
        });
        this.commercialExportSignalFilter.setItems(items);
    }

    public setCommercialExportDefaultDateRange() {
        const endDate = new Date();
        const startDate = new Date();
        startDate.setDate(startDate.getDate() - 30);
        this.getTemplateViewModel().commercialExportDateFilter.startDate(this.formatDate(startDate));
        this.getTemplateViewModel().commercialExportDateFilter.endDate(this.formatDate(endDate));
    }

    protected formatDate(date: Date): string {
        const year = date.getFullYear();
        const month = ('0' + (date.getMonth() + 1)).slice(-2);
        const day = ('0' + date.getDate()).slice(-2);
        return `${year}-${month}-${day}`;
    }

    public getCommercialExportViewModelForRequest() {
        return {
            filters: {
                startDate: this.getTemplateViewModel().commercialExportDateFilter.startDate,
                endDate: this.getTemplateViewModel().commercialExportDateFilter.endDate,
                brands: this.getTemplateViewModel().commercialExportBrandFilter.selectedItems,
                commercialSignals: this.getTemplateViewModel().commercialExportSignalFilter.selectedItems
            }
        }
    }

    public setCommercialExportModalVisible(isVisible: boolean) {
        this.getTemplateViewModel().isCommercialExportModalVisible(isVisible);
    }

    public setCommercialExportState(isExporting: boolean, progressText: string = '') {
        this.getTemplateViewModel().commercialExportInProgress(isExporting);
        this.getTemplateViewModel().commercialExportProgressText(progressText);
    }

    public setCommercialExportCancelling(isCancelling: boolean) {
        this.getTemplateViewModel().commercialExportCancelling(isCancelling);
    }

    public setPollImportModalVisible(isVisible: boolean) {
        this.getTemplateViewModel().isPollImportModalVisible(isVisible);
    }

    public setPollImportDragOver(isDragOver: boolean) {
        this.getTemplateViewModel().isPollImportDragOver(isDragOver);
    }

    public setPollImportFileName(fileName: string) {
        this.getTemplateViewModel().pollImportFileName(fileName);
    }

    public setPollImportInProgress(isImporting: boolean) {
        this.getTemplateViewModel().pollImportInProgress(isImporting);
    }

    public setPollImportValidationState(isValidating: boolean, isValid: boolean, errors: Array<string> = []) {
        this.getTemplateViewModel().pollImportValidating(isValidating);
        this.getTemplateViewModel().pollImportIsValid(isValid);
        this.getTemplateViewModel().pollImportValidationErrors(errors);
    }

    public getPollImportGenerateCommercialSignals(): boolean {
        return this.getTemplateViewModel().pollImportGenerateCommercialSignals();
    }

    public isPollImportValid(): boolean {
        return this.getTemplateViewModel().pollImportIsValid();
    }

    public clearPollImportFile() {
        this.setPollImportDragOver(false);
        this.setPollImportFileName('');
        this.setPollImportValidationState(false, false);

        const fileInput = document.getElementById('poll-import-csv-file') as HTMLInputElement;
        if (fileInput) {
            fileInput.value = '';
        }
    }

    public resetPollImportForm() {
        this.clearPollImportFile();
        this.setPollImportInProgress(false);
        this.getTemplateViewModel().pollImportGenerateCommercialSignals(false);
    }

}



// WEBPACK FOOTER //
// ./js/components/templates/pollsList_template.ts